import { showDangerToast } from "../validation/ToastContainer";
import { securedFetch } from "../auth/authService";
import { DEVICE_API, DeviceStatus, VAR_AUDIT_API, SYSTEM_SETTINGS_API } from "../vars";
import { AuditScope, ChartDynamicLabels, ChartDynamicLabelsCustom } from "./chartDynamicLabels";

export const getMsbViolationsById = (scope, id) => {
    return securedFetch(`${VAR_AUDIT_API}/msb/violations/device/${id}${scope ? '?scope=' + scope : ''}`)
        .then(data => data.json())
        .then(data => {
            return [
                {
                    label: 'Violation',
                    color: "#F53C56",
                    value: data.violation
                },
                {
                    label: 'Suspicious',
                    color: "#FEB969",
                    value: data.suspicious
                },
                {
                    label: 'Normal',
                    color: "#2DCE98",
                    value: data.normal
                },
            ]
        })
        .then(data => {
            const values = [];
            const labels = [];
            const colors = [];
            for (const element of data) {
                labels.push(element.label);
                values.push(element.value);
                colors.push(element.color);
            }
            return { labels: labels, datasets: [{ data: values, backgroundColor: colors }] }
        })
        .catch(err => showDangerToast(err, "Error"));
}

//(1st Chart) This Function to get  compliance data for "Compliance %" Chart at Dashboard Page
export const getCompliance = (scope) => {
    // alert (scope)
    return securedFetch(`${VAR_AUDIT_API}/compliance${scope ? '?scope=' + scope : ''}`)
        .then(data => data.json())
        .then(async data => {
            let labels = [];
            const values = [];
            const color = "#7764E4";
            for (const element of data) {
                values.push(element.value);
            }

            labels = ChartDynamicLabels[scope || AuditScope.BY_DAY]();

            //This code is to get the target value from the SystemSettings database, 
            //then create an array of 32 item with same value as the target value 
            //in order to cover the whole x-axis values in Days and Months            
            const complianceTarget = await securedFetch(`${SYSTEM_SETTINGS_API}/getcompliancetarget`, '', 'GET')
            const targetResponse = await complianceTarget.json();
            const targetValue = targetResponse.value;
            const targetNumValue = Number(targetValue);
            const targetData = Array(32).fill(targetNumValue);
            // const targetData = [32].fill(targetNumValue);


            return {
                labels: labels,
                datasets: [{
                    label: 'Compliance',
                    data: values,
                    fill: false,
                    pointRadius: true,
                    borderColor: color,
                    backgroundColor: color,

                }, {
                    label: 'Target',
                    data: targetData,
                    fill: false,
                    pointRadius: true,
                    borderColor: "#2DCE98",
                    backgroundColor: "#2DCE98"

                }
                ]
            }
        })
}
export const getComplianceCustom = (fromDate, toDate) => {
    // alert (scope)
    return securedFetch(`${VAR_AUDIT_API}/customcompliance?fromDate='${fromDate}'&toDate='${toDate}'`)
        .then(data => data.json())
        .then(async data => {
            let labels = [];
            const values = [];
            const color = "#7764E4";
            for (const element of data) {
                values.push(element.value);
            }

            labels = ChartDynamicLabelsCustom[AuditScope.CUSTOM](fromDate, toDate);

            //This code is to get the target value from the SystemSettings database, 
            //then create an array of 32 item with same value as the target value 
            //in order to cover the whole x-axis values in Days and Months            
            const complianceTarget = await securedFetch(`${SYSTEM_SETTINGS_API}/getcompliancetarget`, '', 'GET')
            const targetResponse = await complianceTarget.json();
            const targetValue = targetResponse.value;
            const targetNumValue = Number(targetValue);
            const targetData = Array(32).fill(targetNumValue);
            // const targetData = [32].fill(targetNumValue);


            return {
                labels: labels,
                datasets: [{
                    label: 'Compliance',
                    data: values,
                    fill: false,
                    pointRadius: true,
                    borderColor: color,
                    backgroundColor: color,

                }, {
                    label: 'Target',
                    data: targetData,
                    fill: false,
                    pointRadius: true,
                    borderColor: "#2DCE98",
                    backgroundColor: "#2DCE98"

                }
                ]
            }
        })
}

//New function to get device-level compliance breakdown at a specific timestamp
export const getComplianceBreakdown = (timestamp, scope) => {
    return securedFetch(`${VAR_AUDIT_API}/compliance/breakdown?timestamp=${timestamp}&scope=${scope}`)
        .then(data => data.json())
        .catch(err => showDangerToast(err, "Error"));
}
//New function to get device compliance trends
export const getDeviceTrends = (scope, fromDate, toDate) => {
    let url = `${VAR_AUDIT_API}/compliance/device-trends?scope=${scope}`;
    if (scope === AuditScope.CUSTOM && fromDate && toDate) {
        url += `&fromDate='${fromDate}'&toDate='${toDate}'`;
    }

    return securedFetch(url)
        .then(data => data.json())
        .catch(err => showDangerToast(err, "Error"));
}

//(2nd Chart) This Function to get MSBViolations data for "Average MSB Violations" Chart at Dashboard Page
export const getDashboardMsbViolations = (scope) => {
    return securedFetch(`${VAR_AUDIT_API}/msb/violations${scope ? '?scope=' + scope : ''}`)
        .then(response => response.json())
        .then(data => {
            const values = [];

            for (const element of data) {
                //values.push({ t: element.label, y: element.value })
                values.push(element.value)
            }

            let labels;

            labels = ChartDynamicLabels[scope || AuditScope.BY_DAY]();

            return {
                labels: labels,
                datasets: [{
                    data: values,
                    label: 'Violations',
                    barThickness: 10,
                    backgroundColor: '#FB6340',
                    hoverBackgroundColor: '#FB6340'
                }]
            }
        })

}
export const getDashboardMsbViolationsCustom = (fromDate, toDate) => {
    return securedFetch(`${VAR_AUDIT_API}/msb/customviolations?fromDate='${fromDate}'&toDate='${toDate}'`)
        .then(response => response.json())
        .then(data => {
            const values = [];

            for (const element of data) {
                //values.push({ t: element.label, y: element.value })
                values.push(element.value)
            }

            let labels;

            labels = ChartDynamicLabelsCustom[AuditScope.CUSTOM](fromDate, toDate);

            return {
                labels: labels,
                datasets: [{
                    data: values,
                    label: 'Violations',
                    barThickness: 10,
                    backgroundColor: '#FB6340',
                    hoverBackgroundColor: '#FB6340'
                }]
            }
        })

}

// New function to get MSB Violation trends by device
export const getMsbViolationsDeviceTrends = (scope, fromDate, toDate) => {
    let url = `${VAR_AUDIT_API}/msb/violations/device-trends?scope=${scope}`;
    if (scope === AuditScope.CUSTOM && fromDate && toDate) {
        url += `&fromDate='${fromDate}'&toDate='${toDate}'`;
    }

    return securedFetch(url)
        .then(data => data.json())
        .catch(err => showDangerToast(err, "Error"));
}

//(3rd Chart) This Function to get RiskScore data for "Risk Score" Chart at Dashboard Page
//the data is filtered on the connected devices
export const getRiskScoreData = (scope) => {
    return securedFetch(`${VAR_AUDIT_API}/risk${scope ? '?scope=' + scope : ''}`)
        .then(response => response.json())
        .then(data => {
            return [
                {
                    label: 'Low',
                    color: "#2DCE98",
                    value: data.low,
                },
                {
                    label: 'Medium',
                    color: "#FEB969",
                    value: data.medium
                },
                {
                    label: 'High',
                    color: "#F53C56",
                    value: data.high,
                },
            ]
        })
        .then(data => {
            const values = [];
            const labels = [];
            const colors = [];
            for (const element of data) {
                labels.push(element.label);
                values.push(element.value);
                colors.push(element.color);
            }
            return { labels: labels, datasets: [{ data: values, backgroundColor: colors }] }
        })
}
export const getRiskScoreDataCustom = (fromDate, toDate) => {
    return securedFetch(`${VAR_AUDIT_API}/customrisk?fromDate='${fromDate}'&toDate='${toDate}'`)
        .then(response => response.json())
        .then(data => {
            return [
                {
                    label: 'Low',
                    color: "#2DCE98",
                    value: data.low,
                },
                {
                    label: 'Medium',
                    color: "#FEB969",
                    value: data.medium
                },
                {
                    label: 'High',
                    color: "#F53C56",
                    value: data.high,
                },
            ]
        })
        .then(data => {
            const values = [];
            const labels = [];
            const colors = [];
            for (const element of data) {
                labels.push(element.label);
                values.push(element.value);
                colors.push(element.color);
            }
            return { labels: labels, datasets: [{ data: values, backgroundColor: colors }] }
        })
}

//(4th Chart) This Function to get ChangesByDate data for "Validation Results" Chart at Dashboard Page
export const getChangesByDate = (scope) => {
    return securedFetch(`${VAR_AUDIT_API}/rule-changelog${scope ? '?scope=' + scope : ''}`)

        .then(data => data.json())
        .then(data => {
            return [
                {
                    label: "Suspicious",
                    color: "#FEB969",
                    data: data.suspicious
                },
                {
                    label: 'Violation',
                    color: "#FB6340",
                    data: data.violation
                },
                {
                    label: 'Normal',
                    color: "#7764E4",
                    data: data.normal
                }
            ]
        }).then(data => {
            const labels = ChartDynamicLabels[scope || AuditScope.BY_DAY]();
            const datasets = [];
            for (const element of data) {
                //const values = element.data.map(el => ({ t: el.label, y: el.value }));
                const values = []
                for (const rec of element.data) {
                    //values.push({ t: element.label, y: element.value })
                    values.push(rec.value)
                }
                //values.push(element.value)
                datasets.push(
                    {
                        label: element.label,
                        data: values,//element.data,//values,
                        barThickness: 25,
                        backgroundColor: element.color,
                        hoverBackgroundColor: element.color
                    }
                )
            }
            return { labels: labels, datasets: datasets };
        })
        .catch(err => showDangerToast(err, "Error"));
}
export const getChangesByDateCustom = (fromDate, toDate) => {
    return securedFetch(`${VAR_AUDIT_API}/customrule-changelog?fromDate='${fromDate}'&toDate='${toDate}'`)

        .then(data => data.json())
        .then(data => {
            return [
                {
                    label: "Suspicious",
                    color: "#FEB969",
                    data: data.suspicious
                },
                {
                    label: 'Violation',
                    color: "#FB6340",
                    data: data.violation
                },
                {
                    label: 'Normal',
                    color: "#7764E4",
                    data: data.normal
                }
            ]
        }).then(data => {
            const labels = ChartDynamicLabelsCustom[AuditScope.CUSTOM](fromDate, toDate);
            const datasets = [];
            for (const element of data) {
                //const values = element.data.map(el => ({ t: el.label, y: el.value }));
                const values = []
                for (const rec of element.data) {
                    //values.push({ t: element.label, y: element.value })
                    values.push(rec.value)
                }
                //values.push(element.value)
                datasets.push(
                    {
                        label: element.label,
                        data: values,//element.data,//values,
                        barThickness: 25,
                        backgroundColor: element.color,
                        hoverBackgroundColor: element.color
                    }
                )
            }
            return { labels: labels, datasets: datasets };
        })
        .catch(err => showDangerToast(err, "Error"));
}

//(5th Chart) This Function to get ViolationsByDevice data for "Violations By Device" Chart at Dashboard Page
export const getViolationsByDevice = (scope) => {

    const colors = [
        "#11CDEF",
        "#7764E4",
        "#2DCE98",
        "#69aefe",
        "#fe6f69",
        "#69feb9",
        "#12CEBF",
        "#7345E4",
        "#2DCE44",
        "#69aebe",
        "#fe4f69",
        "#74ff44",
    ]

    return securedFetch(`${VAR_AUDIT_API}/msb/violations/device${scope ? '?scope=' + scope : ''}`)
        .then(response => response.json())
        .then(data => {
            const labels = ChartDynamicLabels[scope || AuditScope.BY_DAY]();
            const datasets = [];
            let colorIndex = 0;
            let dsElementId = 0;
            for (const element of data.datasets) {
                dsElementId += 1;
                if (colorIndex > colors.length - 1) {
                    colorIndex = 0;
                }

                datasets.push({
                    id: dsElementId,
                    label: element.label,
                    data: element.data,
                    backgroundColor: colors[colorIndex],
                    hoverBackgroundColor: colors[colorIndex],
                    categoryPercentage: 0.2
                })

                colorIndex++;
            }
            return { labels: labels, datasets: datasets }
        })
}
export const getViolationsByDeviceCustom = (fromDate, toDate) => {

    const colors = [
        "#11CDEF",
        "#7764E4",
        "#2DCE98",
        "#69aefe",
        "#fe6f69",
        "#69feb9",
        "#12CEBF",
        "#7345E4",
        "#2DCE44",
        "#69aebe",
        "#fe4f69",
        "#74ff44",
    ]

    return securedFetch(`${VAR_AUDIT_API}/msb/customviolations/device?fromDate='${fromDate}'&toDate='${toDate}'`)
        .then(response => response.json())
        .then(data => {
            const labels = ChartDynamicLabelsCustom[AuditScope.CUSTOM](fromDate, toDate);
            const datasets = [];
            let colorIndex = 0;
            let dsElementId = 0;
            for (const element of data.datasets) {
                dsElementId += 1;
                if (colorIndex > colors.length - 1) {
                    colorIndex = 0;
                }

                datasets.push({
                    id: dsElementId,
                    label: element.label,
                    data: element.data,
                    backgroundColor: colors[colorIndex],
                    hoverBackgroundColor: colors[colorIndex],
                    categoryPercentage: 0.2
                })

                colorIndex++;
            }
            return { labels: labels, datasets: datasets }
        })
}

//(6th Chart) This Function to get Status data for "Status" Chart at Dashboard Page
export const getStatusData = async () => {

    const devices = await securedFetch(DEVICE_API)
        .then(response => response.json())

    const connected = devices.filter(device => device.status === DeviceStatus.CONNECTED).length;
    const disconnected = devices.filter(device => device.status === DeviceStatus.DISCONNECTED).length;
    const unknown = devices.filter(device => device.status === DeviceStatus.UNKNOWN).length;

    const values = [connected, disconnected, unknown];
    // const labels = ["Connected", "Disconnected", "Unknown"];
    // const colors = ['#2DCE98', '#FEB969', '#F53C56'];
    const labels = ["Connected", "Disconnected"];
    const colors = ['#2DCE98', '#FEB969'];
    return { labels: labels, datasets: [{ data: values, backgroundColor: colors }] }
}

export const getChangesByDateByDeviceId = (scope, deviceId) => {
    return securedFetch(`${VAR_AUDIT_API}/rule-changelog/device/${deviceId}${scope ? '?scope=' + scope : ''}`)

        .then(data => data.json())
        .then(data => {
            return [
                {
                    label: "Suspicious",
                    color: "#FEB969",
                    data: data.suspicious
                },
                {
                    label: 'Violation',
                    color: "#FB6340",
                    data: data.violation
                },
                {
                    label: 'Normal',
                    color: "#7764E4",
                    data: data.normal
                }
            ]
        }).then(data => {
            const labels = ChartDynamicLabels[scope || AuditScope.BY_DAY]();
            const datasets = [];
            for (const element of data) {
                const values = element.data.map(el => ({ t: el.label, y: el.value }));
                datasets.push(
                    {
                        label: element.label,
                        data: values,
                        barThickness: 25,
                        backgroundColor: element.color,
                        hoverBackgroundColor: element.color
                    }
                )
            }
            return { labels: labels, datasets: datasets };
        })
        .catch(err => showDangerToast(err, "Error"));
}

//Updated by Octopus DevTeam December 14,2022 to set the x and y axis titles
export const ChartConfigs = {
    BAR: {
        maintainAspectRatio: false,
        responsive: true,
        // legend: {
        //     display: true
        // },
        scales: {
            x: {
                offset: true,
                stacked: true,
                distribution: 'series',
                grid: {
                    drawOnChartArea: false,
                },
                title: {
                    display: true,
                    text: 'Date'
                }
            },
            y: {
                beginAtZero: true,
                display: true,
                stacked: true,
                title: {
                    display: true,
                    text: 'Number of Changes'
                }
            },
        }
    },
    DOUGHNUT: {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: {
                position: 'right',
            },
        },
    },
    LINE: {
        //intersect: false,
        //barRoundness: 1,
        maintainAspectRatio: false,
        responsive: true,
        // plugins: {
        //     legend: {
        //         display: true,
        //         position: 'top',
        //         borderRadius: 0,
        //         //fillStyle: Color,
        //     },
        //   },
        scales: {
            x: {
                type: 'category',
                display: true,
                grid: {
                    drawOnChartArea: false,
                },
                title: {
                    display: true,
                    text: 'Date'
                }
            },
            y: {
                beginAtZero: true,
                display: true,
                title: {
                    display: true,
                    text: 'Compliance & Target %'
                }
            },
        },

        // scales: {
        //     xAxes: [{
        //         gridLines: {
        //             display: false,
        //         },
        //         scaleLabel: {
        //             display: true,
        //             labelString: 'Date'
        //         }

        //     }],
        //     yAxes: [{
        //         gridLines: {
        //             display: false,
        //             // borderDash: [5, 3]
        //         },
        //         ticks: {
        //             stepSize: 15,
        //             min: 0
        //         },
        //         scaleLabel: {
        //             display: true,
        //             labelString: 'Compliance & Target %'
        //         }

        //     }]
        // }

    },

    // const options = {
    //     scales: {
    //       x: {
    //         type: 'category', // use 'category' type for the x-axis
    //         labels: data.labels,
    //       },
    //       y: {
    //         beginAtZero: true,
    //       },
    //     },
    //   };
    //TODO rename
    BAR_2: {
        // barRoundness: 1,
        maintainAspectRatio: false,
        responsive: true,
        scales: {
            x: {
                offset: true,
                //stacked: true,
                distribution: 'linear',
                grid: {
                    drawOnChartArea: false,
                },
                title: {
                    display: true,
                    text: 'Date'
                }
            },
            y: {
                beginAtZero: true,
                display: true,
                title: {
                    display: true,
                    text: 'Average Number of Violations'
                }
            },
        }
        // scales: {
        //     xAxes: [{
        //         offset: true,
        //         distribution: 'linear',
        //         gridLines: {
        //             display: false,
        //         },
        //         scaleLabel: {
        //             display: true,
        //             labelString: 'Date'
        //         }
        //     }],
        //     yAxes: [{
        //         gridLines: {
        //             display: true,
        //             borderDash: [5, 3]
        //         },
        //         ticks: {
        //             beginAtZero: true,
        //             stepSize: 5
        //         },
        //         scaleLabel: {
        //             display: true,
        //             labelString: 'Average Number of Violations'
        //         }
        //     }]
        // }
    },
    TRIPLE_BAR: {
        barRoundness: 1,
        maintainAspectRatio: false,
        responsive: true,
        legend: {
            display: true,
            // position: "bottom"
        },
        scales: {
            x: {
                offset: true,
                grid: {
                    drawOnChartArea: false,
                },
                title: {
                    display: true,
                    text: 'Date'
                }
            },
            y: {
                grid: {
                    drawOnChartArea: true,
                    borderDash: [5, 3]
                },
                ticks: {

                    stepSize: 10,
                    min: 0
                },
                title: {
                    display: true,
                    text: 'Number of Violations'
                }
            }
        }
    },
    PIE: {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: {
                position: 'right',
            },
        },
    },
    PIE_DISK_USAGE: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
            display: false
        }
    },
    DOUGHNUT_SYSTEM_LOAD: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
            display: false
        }
    }
}

